/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface JiraStatusSyncStatusMapping
 */
export interface JiraStatusSyncStatusMapping {
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSyncStatusMapping
     */
    clearflaskStatusId: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSyncStatusMapping
     */
    jiraStatusName: string;
}

export function JiraStatusSyncStatusMappingFromJSON(json: any): JiraStatusSyncStatusMapping {
    return {
        'clearflaskStatusId': json['clearflaskStatusId'],
        'jiraStatusName': json['jiraStatusName'],
    };
}

export function JiraStatusSyncStatusMappingToJSON(value?: JiraStatusSyncStatusMapping): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'clearflaskStatusId': value.clearflaskStatusId,
        'jiraStatusName': value.jiraStatusName,
    };
}


